/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_CapTable_Dtos_Common_LatestAndPriorStockData } from '../models/Wealthlane_CapTable_Dtos_Common_LatestAndPriorStockData';
import type { Wealthlane_CapTable_Dtos_Common_StatusDto } from '../models/Wealthlane_CapTable_Dtos_Common_StatusDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class WarrantSharedService {

    /**
     * @returns Wealthlane_CapTable_Dtos_Common_StatusDto OK
     * @throws ApiError
     */
    public static getApiCapTableApiAppWarrantSharedWarrantSettlementTypes(): CancelablePromise<Array<Wealthlane_CapTable_Dtos_Common_StatusDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/cap-table/api/app/warrant-shared/warrant-settlement-types',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_CapTable_Dtos_Common_StatusDto OK
     * @throws ApiError
     */
    public static getApiCapTableApiAppWarrantSharedWarrantExerciseStatuses(): CancelablePromise<Array<Wealthlane_CapTable_Dtos_Common_StatusDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/cap-table/api/app/warrant-shared/warrant-exercise-statuses',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_CapTable_Dtos_Common_LatestAndPriorStockData OK
     * @throws ApiError
     */
    public static getApiCapTableApiAppWarrantSharedCurrentFMv(): CancelablePromise<Wealthlane_CapTable_Dtos_Common_LatestAndPriorStockData> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/cap-table/api/app/warrant-shared/current-fMV',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
